import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcFoldertStore from '@/frontapp/store/bcFolder'
import PublishDocument from './actions/PublishDocument'
import DocumentStore from './DocumentStore'

export default {
  mixins: [
    DocumentStore,
  ],
  computed: {
    showPublishDocumentBtn () {
      return this.$route.matched[0].name === 'BCDocument' && this.bcDocumentStore?.edit === true
    },
    isActivePublishDocumentBtn () {
      return this.bcDocumentStore?.document?.published__bc_document_rev_id !== this.bcDocumentStore?.documentRev
        || this.bcDocumentStore?.document?.hidden
    },
    loading() {
      return this.bcDocumentStore?.promiseQueueState === 1 || this.bcDocumentStore.uploadersRunning.size > 0 // promise queue is running
    },
    ...mapStores(useBcSelectedStore, useBcFoldertStore),
  },
  methods: {
    async clickPublishDocument() {
      await PublishDocument(this.bcDocumentStore, this.bcFolderStore, this.$router, this.$t)
    }
  }
}